import React from 'react'

function DarkText ({ children, size = 'text-sm md:text-base', className = '' }) {
  return (
    <div className={className + ' font-medium ' + (size)}>
      {children}
    </div>
  )
}

export default DarkText
